// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconDebtPath = 'M20 7v13H2v-9h.69A5.997 5.997 0 0 1 0 6c0-3.309 2.691-6 6-6s6 2.691 6 6c0 .342-.035.674-.09 1H20Zm-2 5V9h-6.812a6.05 6.05 0 0 1-.897 1.187c.211-.116.451-.187.709-.187a1.5 1.5 0 1 1-1.253.679A5.967 5.967 0 0 1 6 12a5.971 5.971 0 0 1-2-.35V14h14v-2Zm0 4v2H4v-2h14ZM2 6c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4Zm1.71 1.582 1.697 1.061L7 6.094V3.5H5v2.02L3.71 7.582Z';
var IconDebt = baseIcon('IconDebt', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconDebtPath
});
export default IconDebt;
//# sourceMappingURL=index.js.map